<template>
    <fieldset :disabled="!contactSelectExtension">

        <div v-for="section in ['contact', 'lines']" class="mb-3">
            <div class="custom-control custom-checkbox">
                <input :value="!!params.override[section]['enabled']"
                       :checked="!!params.override[section]['enabled']"
                       @change="$emit('update', {path: ['override', section, 'enabled'], value: !params.override[section]['enabled']})"
                       class="custom-control-input"
                       type="checkbox"
                       :id="`override-${section}-enabled`">
                <label class="custom-control-label pt-1" :for="`override-${section}-enabled`">
                    Override <span class="text-bold">{{ section }}</span> section data
                </label>
            </div>
            <fieldset :disabled="!params.override[section]['enabled']" class="ml-4">
                <div class="custom-control custom-checkbox">
                    <input :value="!!params.override[section]['confirm']"
                           :checked="!!params.override[section]['confirm']"
                           @change="$emit('update', {path: ['override', section, 'confirm'], value: !params.override[section]['confirm']})"
                           class="custom-control-input"
                           type="checkbox"
                           :id="`override-${section}-confirm`">
                    <label class="custom-control-label pt-1" :for="`override-${section}-confirm`">
                        With confirmation
                        <span
                            v-tooltip="'Additionally, ask for confirmation of updating the form data.</br>In some cases, you may need to opt out of updating your data.'">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input :value="!!params.override[section]['force']"
                           :checked="!!params.override[section]['force']"
                           @change="$emit('update', {path: ['override', section, 'force'], value: !params.override[section]['force']})"
                           class="custom-control-input"
                           type="checkbox"
                           :id="`override-${section}-force`">
                    <label class="custom-control-label pt-1" :for="`override-${section}-force`">
                        Force replace
                        <span
                            v-tooltip="'Even if there are selected values in the form, they will be overwritten with the data of the selected contact.'">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                </div>
            </fieldset>
        </div>
        <div class="custom-control custom-checkbox">
            <input :value="!!forceOverrideDueDate"
                   :checked="!!forceOverrideDueDate"
                   @change="$emit('update', {path: ['override', 'dateDue', 'force'], value: !forceOverrideDueDate})"
                   class="custom-control-input"
                   type="checkbox"
                   id="override-due-date-force">
            <label class="custom-control-label pt-1" for="override-due-date-force">
                Force override document <span class="text-bold">Due date</span>
                <span
                    v-tooltip="`For each document, we try to verify the due date with the matched ${$lang.subsidiary.singular} details (considered with payment terms/period). This flag tells the system to always override the due date of the document with the calculated value (by default calculated value will be used only if the document due date is empty).`"
                    class="pl-1">
                    <i class="fal fa-info-circle"></i>
                </span>
            </label>
        </div>
    </fieldset>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'ContactSelectExtensionParamsEditor',
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'contactSelectExtension'
        ]),

        forceOverrideDueDate() {
            return _.get(this.params, ['override', 'dateDue', 'force'])
        }
    }
}
</script>
